export default __webpack_public_path__ + "static/media/patterns-no-5.1ec39cec.ogg";